import { forwardRef, memo, type RefCallback } from 'react';

import { useMergeRefs } from '@/js/libs/hooks/useMergeRefs/index.ts';

import type { InputProps } from '../../common/index.ts';
import { Input } from '../../Input/index.tsx';
import { DATE_PICKER_REF } from '../constants.ts';

export const DatePickerInput = memo(
  forwardRef<HTMLInputElement, InputProps & { datePickerRef?: RefCallback<HTMLInputElement | null> }>(function DatePickerInput(
    { [DATE_PICKER_REF]: datePickerRef, ...props },
    ref,
  ) {
    const mergedRef = useMergeRefs(datePickerRef, ref);

    return <Input ref={mergedRef} {...props} />;
  }),
);
